import { Form, Select } from 'antd';
import StoreSelector from 'components/StoreSelector';
import { useTranslate } from '@tolgee/react';
import FormItem from 'antd/lib/form/FormItem';

interface StoreFormFieldProps {
  platform: General.PlatformUpperCase;
  filterType: 'return' | 'cancel';
  disabled?: boolean;
}

const supportStoreTypePlatforms: General.PlatformUpperCase[] = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
  'MERCADO',
];

export const StoreFormField = (props: StoreFormFieldProps) => {
  const { platform, filterType, disabled } = props;
  const { t } = useTranslate();

  const storeTypeUI = (
    <FormItem name="storeType">
      <Select
        disabled={disabled}
        placeholder={t('scene.orderWorkspace.returnRefundTab.filter.storeType')}
        className="storeType"
      >
        <Select.Option value="">
          {t('scene.orderWorkspace.returnRefundTab.filter.all')} -{' '}
          {t('scene.orderWorkspace.returnRefundTab.filter.storeType')}
        </Select.Option>
        <Select.Option value="LOCAL">{t('domain.store.type.localStore')}</Select.Option>
        <Select.Option value="CROSS">{t('domain.store.type.crossBorderStore')}</Select.Option>
      </Select>
    </FormItem>
  );

  return (
    <>
      <Form.Item name="region" className="!hidden" />
      <Form.Item name="follower" className="!hidden" />
      <Form.Item name="storeList" className="!hidden" />
      <Form.Item className="!mb-0" dependencies={['region', 'follower', 'storeList']}>
        {({ getFieldValue, setFieldsValue }) => {
          const region = getFieldValue('region');
          const follower = getFieldValue('follower');
          const storeList = getFieldValue('storeList');

          const hasValue = Boolean(
            region || follower === '1' || (storeList && storeList.length > 0),
          );

          return (
            <StoreSelector
              disabled={disabled}
              scene="VIEW_CANCEL_ORDER"
              platformLimit={platform}
              displayUnreadCount={false}
              displayTriggerIcon={false}
              value={{
                region,
                follower,
                storeList,
              }}
              onChange={(value) => {
                const { region, follower, storeList } = value;

                setFieldsValue({
                  region,
                  follower,
                  storeList,
                });
              }}
              displayNodeRender={(displayNode) => {
                return (
                  <Select
                    disabled={disabled}
                    className="storeSelect"
                    mode="multiple"
                    showArrow
                    placeholder={t('scene.orderWorkspace.returnRefundTab.filter.selectStore')}
                    value={hasValue ? ['value'] : []}
                    tagRender={() => <>{displayNode}</>}
                    open={false}
                  />
                );
              }}
            />
          );
        }}
      </Form.Item>
      {supportStoreTypePlatforms.includes(platform) && filterType === 'return' && storeTypeUI}
    </>
  );
};
